import SearchWarehouses from '@/components/SearchWarehouses/SearchWarehouses';
import { useUserState } from '@/context/user.context';
import { CompanyType } from '@/types/common-entities';

import Custom403 from '../403';

export default function Search() {
	const { user } = useUserState();

	if (user && user.companyType === CompanyType.Warehouse) {
		return <Custom403 />;
	}

	return <SearchWarehouses />;
}
